// Given this in the $scope:
// $scope.type = 'RFP' or $scope.type = 'SIO';
// and
// $scope.id = 2352;
//
// And a directive like this in the HTML:
// <div offer-type="type" ot-request-id="id"></dir>
//
// You will get the standard offer type section replacing the <div>.
export default function OfferTypeDirective($log) {
  'ngInject';

  return {
    restrict: 'A',
    scope: {
      rfpType: '=offerType',
      requestId: '=otRequestId'
    },
    template:
      '<div class="offerType" ng-show="rfpType">' +
      '  <h2>Offer Type</h2>' +
      '  <span ng-class="{ active : rfpType == \'RFP\' }">' +
      '  Request For Pricing<span ng-if="rfpType == \'RFP\'">: ID {{ requestId }}</span>' +
      '  </span><br>' +
      '  <span ng-class="{ active : rfpType == \'SIO\' }">' +
      '  Seller Initiated Offer <span ng-if="rfpType == \'SIO\'">: ID {{ requestId }}</span>' +
      '  </span>' +
      '</div>',
    replace: true
  };
}
